// Generated by genversion.
export const version = '5.1228.0';
